import { render, staticRenderFns } from "./DonationsTableView.vue?vue&type=template&id=7548e5fa&scoped=true&"
import script from "./DonationsTableView.vue?vue&type=script&lang=js&"
export * from "./DonationsTableView.vue?vue&type=script&lang=js&"
import style0 from "./DonationsTableView.vue?vue&type=style&index=0&id=7548e5fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7548e5fa",
  null
  
)

export default component.exports